<div class="spen-mod-segmentation">
  @for (tab of tabKeys; track tab) {
    <a class="segment-column" [class.is-primary]="isActiveTab(tab)" (click)="onChangeTab(tab)">
      @if (tabBadge[tab]) {
        <span class="segment-badge"></span>
      }
      {{ tabValue(tab) }}
    </a>
  }
</div>
